var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenshift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#db212f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.424 27.158 7.8 30.664c.123 1.545.4 3.07.764 4.566l9.15-3.333a17.876 17.876 0 0 1-.28-4.74M60 16.504a27.584 27.584 0 0 0-2.35-3.988l-9.632 3.506a18.028 18.028 0 0 1 2.83 3.813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.802 13.776a17.79 17.79 0 0 1 5.204 3.707l9.633-3.506a27.38 27.38 0 0 0-10.756-8.95c-13.77-6.42-30.198-.442-36.62 13.326a27.38 27.38 0 0 0-2.488 13.771l9.634-3.505c.16-2.087.67-4.18 1.603-6.184 4.173-8.947 14.844-12.83 23.79-8.658"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ea2227",
    d: "M9.153 35.01 0 38.342a27.89 27.89 0 0 0 4.304 9.33l9.612-3.5a17.99 17.99 0 0 1-4.763-9.164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#db212f",
    d: "M49.074 31.38a17.64 17.64 0 0 1-1.616 6.186c-4.173 8.947-14.843 12.83-23.79 8.657a17.71 17.71 0 0 1-5.215-3.7l-9.612 3.5a27.324 27.324 0 0 0 10.748 8.953c13.77 6.42 30.196.44 36.618-13.328a27.28 27.28 0 0 0 2.479-13.765l-9.61 3.498z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea2227",
    d: "m51.445 19.618-9.153 3.332a17.968 17.968 0 0 1 2.24 10.08l9.612-3.497a27.755 27.755 0 0 0-2.7-9.915"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenshift);
export default __webpack_public_path__ + "static/media/openshift.43a9b2674915f2926b8aad082b54f196.svg";
export { ForwardRef as ReactComponent };